export const artLevel = art => art?.level ?? art?.from ?? 1;

export const baseArt = arts => arts.find(art => art.level === undefined && art.from === undefined) || arts[0];

export function unlockedArts(arts, level) {
  const unlocked = arts.filter(art => artLevel(art) <= level);
  return unlocked.length ? unlocked : arts.slice(0, 1);
}

export function selectCardArt(arts, { mode = 'manual', unlockedLevel = Infinity, runLevel = null, selected, soft = false } = {}) {
  if (mode === 'dynamic' && runLevel === null)
    return baseArt(arts)?.img;

  const unlocked = unlockedArts(arts, unlockedLevel);
  if (mode === 'max-size' || mode === 'dynamic') {
    const available = mode === 'dynamic' ? arts.filter(art => artLevel(art) <= runLevel) : unlocked;
    const highest = available.reduce((best, art) => !best || artLevel(art) > artLevel(best) ? art : best, undefined);
    return (highest || baseArt(arts))?.img;
  }

  if (selected && unlocked.some(art => art.img === selected))
    return selected;
  if (soft) {
    const softArt = unlocked.find(art => art.soft);
    if (softArt)
      return softArt.img;
  }
  return unlocked[0]?.img;
}
